/// <reference path="../../../tools/typings/tsd.d.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export class Webhook {

        id                  : number = null;
        location_id         : number = null;
        type                : string = null;
        action              : string = null;
        trigger             : string = null;
        url                 : string = null;
        auth_header_name    : string = null;
        auth_header_value   : string = null;
        handshake           : boolean = null;
        active              : boolean = null;
        object_version      : number = 2;

        data                : any = { };
        master              : any = { };

        index               : number;

        // Not data properties for the Webhook object.
        //
        public nonObjectProperties: any = [
            '$injector', 'nonObjectProperties', 'defaults', '$q', 'WebhookModel',
            'webhookResources', 'typeDisplay', 'actionDisplay', 'objectConstantProperties'
        ];

        // These properties are static as initialized above.
        //
        public objectConstantProperties: any = [
            'object_version'
        ]

        public defaults         : any = { };

        private $q              : any;
        private WebhookModel    : any;
        private webhookResources: any;

        constructor (
            public $injector : any
        ) {
            this.$q             = this.$injector.get ('$q');
            this.WebhookModel   = this.$injector.get ('WebhookModel');
            this.webhookResources = this.$injector.get('webhookResources');
        }

        initialize (initialization?: any) : Webhook {
            this.fill (<Webhook>initialization);
            this.defaults = angular.copy(this);
            return this;
        }

        clear () : void {
            this.fill();
        }

        fill (webhook?: Webhook) : void {

            Object.keys(this).forEach( ( key: string ) => {
                if ( this.nonObjectProperties.indexOf(key) === -1
                     && this.objectConstantProperties.indexOf(key) === -1
                   ) {
                    (<any>this)[key] = webhook ? (<any>webhook)[key] : null;
                    this.defaults[key] = (<any>this)[key];
                }
            });
        }

        private get typeDisplay () : string {
            return this.getTypeDisplay (this.type);
        }

        getTypeDisplay ( thisType: string ) : string {

            var returnText: string = '';

            this.webhookResources.forEach( ( type: any ) => {
                if (type.value === thisType) {
                    returnText = type.displayText;
                }
            });

            return returnText;
        }

        private get actionDisplay () : string {
            return this.getActionDisplay (this.type, this.action, this.trigger);
        }

        getActionDisplay ( thisType: string, thisAction: string, trigger: string ) : string {

            var returnText: string = '';

            this.webhookResources.forEach( ( type: any ) => {
                if (type.value === thisType) {
                    type.options.forEach( ( action: any ) => {
                        var actionTriggerText = thisAction + (trigger === null ? '' : '-' + trigger)

                        if (action.value === actionTriggerText) {
                            returnText = action.displayText;
                        }
                    });
                }
            });

            return returnText;
        }

        get typeAction () : string {
            return this.action + (this.trigger ? '-' + this.trigger : '');
        }

        set typeAction (typeAction: string) {
            var match = typeAction.match(/^(\w+)\-?(\w*)$/)
            this.action = match[1];
            this.trigger = match[2];
        }

        private add () : ng.IPromise<any> {
            return this.doSave();
        }

        private update (id? : number) : ng.IPromise<any> {
            return this.doSave (id);
        }

        save (id? : number) : ng.IPromise<any> {

            if (id || this.id) {
                return this.update (id);
            }
            else {
                return this.add ();
            }
        }

        private doSave (id? : number) : ng.IPromise<any> {

            var that = this;

            var deferred = this.$q.defer();

            var saveMethod = id || this.id ? 'update' : 'create';

            var params : any = {
                include_location    : true,
                include_address     : true
            };
            if (this.id) {
                //params.location_id = id || this.id;
            }

            this.WebhookModel[saveMethod] ({
                promise : true,
                data    : this.mapToBaseProperties(),
                params  : params
            })
                .then( (webhookData : any) => {
                    deferred.resolve(that);
                })
                .catch( (response: any) => {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        private mapToBaseProperties () : any {
            var baseProperties : any = { };
            Object.keys(this).forEach( ( key: string ) => {
                if (this.nonObjectProperties.indexOf(key) === -1) {
                    baseProperties[key] = (<any>this)[key];
                }
            });
            return baseProperties;
        }

        delete (location_id? : number, id?: number) : ng.IPromise<any> {

            var deferred = this.$q.defer();

            this.WebhookModel.delete ({
                promise : true,
                params  : {
                    location_id : location_id || this.location_id,
                    id          : id || this.id
                }
            })
                .then( ( ) => {
                    deferred.resolve(this);
                })
                .catch( (response: any) => {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        isWebHookUnchanged () : boolean {

            var that = this;

            var isUnchangedResult = Object
                .keys (this.defaults)
                .every ( ( key: string ) => {
                    return key === 'settings'
                        || (<any>that)[key] === that.defaults[key];
                });

            return isUnchangedResult;
        }
    }

    getDealerwareWebServicesModule()
        .service ('Webhook', Webhook);


    export class WebhookFactory {

        public static $inject: string[] = [ '$injector' ];

        constructor (
            public $injector: any
        ) { }

        public getInstance () : Webhook {
            return new Webhook (this.$injector);
        }
    }

    getDealerwareWebServicesModule ()
        .service('DealerwareWebhookFactory', WebhookFactory);
}
